import { gql } from 'graphql-tag'

export const fetchAllWastageBoundariesForAllProductTypes = gql`
  query GetAllWastageBoundariesForAllProductTypes($stationId: ID!) {
    getAllWastageBoundariesForAllProductTypes(stationId: $stationId) {
      id
      productType
      lowerWastageBounds
      upperWastageBounds
    }
  }
`

export const upsertWastageBoundary = gql`
  mutation UpdateWastageBoundary($stationId: ID!, $id: String, $data: UpdateWastageBoundaryType) {
    updateWastageBoundariesForProductType(stationId: $stationId, id: $id, data: $data) {
      id
      productType
      lowerWastageBounds
      upperWastageBounds
    }
  }
`
